<template>
    <div>
        <div v-if="loading" class="text-center" style="margin-top: 10em">
            <div class="lds-roller">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
        <div v-else>
            <transition appear name="slide-fade">
                <div>
                    <div class="row">
                        <div class="col-lg-12">
                            <h3 class="text-orange">Usuarios</h3>
                            <hr />
                        </div>
                        <div class="col-lg-12 text-end mb-3">
                            <router-link to="/nueva_membresia" class="btn btn-orange btn-lg rounded-pill">
                                <i class="bx bxs-plus-circle"></i> Nuevo usuario
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-7 d-flex align-items-stretch">
                            <div v-if="total_aliados != 0" class="card card-body text-center pt-4">
                                <apexchart type="bar" :options="chart.options" :series="chart.series"></apexchart>
                                <div class="text-end mt-2">
                                    <h5 class="fw-bold text-orange">
                                        {{ total_aliados }} Aliados
                                    </h5>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-5 d-flex align-items-stretch">
                            <div class="card card-body">
                                <div class="list-group">
                                    <router-link to="/usuarios" class="list-group-item list-group-item-action"
                                        aria-current="true">
                                        <i class="bx bx-table"></i>
                                        Panel general
                                    </router-link>
                                    <router-link to="/agentes_usuarios" class="list-group-item list-group-item-action">
                                        <i class="bx bx-user-voice"></i>
                                        Agentes
                                    </router-link>
                                    <router-link to="/ruta_usuarios" class="list-group-item list-group-item-action">
                                        <i class='bx bx-mail-send'></i>
                                        Rutas
                                    </router-link>
                                    <router-link to="/beneficios_usuarios" class="list-group-item list-group-item-action">
                                        <i class="bx bx-list-check"></i>
                                        Beneficios
                                    </router-link>
                                    <a v-on:click="download" href="javascript:void(0)"
                                        class="list-group-item list-group-item-action">
                                        <i class="bx bx-download"></i>
                                        Descargar
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";

export default {
    name: "Aliados",
    metaInfo: {
        title: "Aliados - Reddy Backoffice",
    },

    data() {
        return {
            loading: true,
            total_aliados: 0,
            sucursal: null,
            sucursales: [],
            aliados: [],
            aliado: null,
            chart: {
                options: {
                    plotOptions: {
                        bar: {
                            borderRadius: 10,
                            distributed: true,
                        },
                    },
                    legend: {
                        show: false,
                    },
                    xaxis: {
                        categories: ["Interesados", "Pendientes", "Exitosas"],
                        axisBorder: {
                            show: false,
                        },
                        axisTicks: {
                            show: false,
                        },
                    },
                    colors: ["#6296FE", "#FF4D4D", "#FFC100", "#39BB00"],
                },
                series: [
                    {
                        name: "Aliados",
                        data: [0, 0, 0, 0],
                    },
                ],
            },
        };
    },
    props: {
        session: Object,
    },
    created: function () {
        if (this.session.usuario.perfil != 0) {
            this.$router.push("/usuarios");
        }
        this.get_resumen_aliados();
        this.get_sucursales();
        var sucursal = localStorage.getItem("sucursal");
        if (sucursal != undefined) {
            this.sucursal = JSON.parse(sucursal);
        }
    },
    methods: {
        get_resumen_aliados: function () {
            var id_sucursal = null;
            if (this.sucursal != null) {
                id_sucursal = this.sucursal.id_sucursal;
            }
            const headers = {
                "Content-Type": "application/json",
                "x-api-key": this.$api_key,
                token: this.session.token,
            };
            let config = {
                headers: headers,
                params: {
                    id_sucursal: id_sucursal,
                },
            };
            axios
                .get(this.$base_url + "clientes/resumen_clientes", config, {
                    headers: headers,
                })
                .then((response) => {
                    if (!response.data.status) {
                        this.$notify({
                            type: "error",
                            group: "foo",
                            title: "Ups!",
                            text: response.data.message,
                        });
                    }
                    this.total_aliados = response.data.data.total;
                    this.chart.series[0].data = response.data.data.chart;
                    this.loading = false;
                })
                .catch((error) =>
                    this.$notify({
                        type: "error",
                        group: "foo",
                        title: "Ups!",
                        text: error,
                    })
                )
                .finally();
        },
        set_aliado: function () {
            this.loading = true;
            const vm = this;
            const headers = {
                "Content-Type": "application/json",
                "x-api-key": this.$api_key,
                token: this.session.token,
            };
            var params = {};
            axios
                .post(this.$base_url + "aliados/set_aliado", params, {
                    headers: headers,
                })
                .then((response) => {
                    if (!response.data.status) {
                        vm.$notify({
                            type: "error",
                            group: "foo",
                            title: "Error",
                            text: response.data.message,
                        });
                        return false;
                    }
                    vm.$router.push(
                        "/aliado/info_basica/" + response.data.data.id_aliado
                    );
                    vm.loading = false;
                })
                .catch(
                    (error) =>
                        vm.$notify({
                            type: "error",
                            group: "foo",
                            title: "Important message",
                            text: error,
                        }),
                    (vm.loading = false)
                )
                .finally();
        },
        get_sucursales: function () {
            const headers = {
                "Content-Type": "application/json",
                "x-api-key": this.$api_key,
                token: this.session.token,
            };
            let config = {
                headers: headers,
            };
            axios
                .get(this.$base_url + "admin/sucursales", config, {
                    headers: headers,
                })
                .then((response) => {
                    if (!response.data.status) {
                        this.$notify({
                            type: "error",
                            group: "foo",
                            title: "Ups!",
                            text: response.data.message,
                        });
                    }
                    this.sucursales = response.data.data.sucursales;
                })
                .catch((error) =>
                    this.$notify({
                        type: "error",
                        group: "foo",
                        title: "Ups!",
                        text: error,
                    })
                )
                .finally();
        },
        set_sucursal: function () {
            localStorage.setItem("sucursal", JSON.stringify(this.sucursal));
            this.$router.push("/panel_aliados");
        },
        get_aliados: function (search) {
            if (search == null || search.trim().length == 0) {
                return false;
            }

            const headers = {
                "Content-Type": "application/json",
                "x-api-key": this.$api_key,
                token: this.session.token,
            };
            let config = {
                headers: headers,
                params: {
                    search: search,
                },
            };
            axios
                .get(this.$base_url + "aliados/aliados", config, {
                    headers: headers,
                })
                .then((response) => {
                    if (!response.data.status) {
                        this.$notify({
                            type: "error",
                            group: "foo",
                            title: "Ups!",
                            text: response.data.message,
                        });
                    }
                    this.aliados = response.data.data.aliados;
                })
                .catch((error) =>
                    this.$notify({
                        type: "error",
                        group: "foo",
                        title: "Ups!",
                        text: error,
                    })
                )
                .finally();
        },
        select_aliado: function () {
            if (this.aliado != null) {
                this.$router.push("/aliado/" + this.aliado.id_aliado);
            }
        },
        download: function () {
            window.open(
                this.$base_url + "download/clientes/" + this.session.token,
                "_blank"
            );
        },
    },
    mounted: function () { },
};
</script>